const eventKey ={
    'announcement': 1,
    'breakfast': 2,
    'lunch': 3,
    'snack': 4,
    'trip': 5,
}

export const sortByEvent = (a, b) => eventKey[a.event] - eventKey[b.event];
